import React, { Fragment } from "react";
import cn from "classnames";
import { times } from "ramda";
import "./style.css";

const Intro = ({ strapline, numOfCircles = 10 }) => {
  const circles = times(
    n => ({
      height: `${Math.random() * 400 + 50}px`,
      left: `${100 / numOfCircles * n +
        1 +
        100 / numOfCircles / 2 * Math.random()}%`,
      marginBottom: `${Math.random() * 200 + 10}px`,
    }),
    numOfCircles
  );

  circles.sort(Math.random);

  return (
    <div id="intro" className="intro">
      <div className="intro__inner">
        <img
          className="intro__logo intro__fade"
          src={"logo.svg"}
          alt={"Logo"}
        />
        <h1 className="intro__strapline">
          {strapline.split(" ").map((word, i) => (
            <Fragment>
              <span className="intro__word intro__fade">{word}</span>
              {i !== strapline.split("").length - 1 ? " " : ""}
            </Fragment>
          ))}
        </h1>
        <div className="falling">
          {circles.map(
            (circle, i) => (
              <div className="falling__circle" style={circle} id={i} />
            ),
            11
          )}
        </div>
      </div>
    </div>
  );
};

export default Intro;



// WEBPACK FOOTER //
// ./src/sections/intro/index.js